/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { Injectable } from '@angular/core';
import { Auth } from '@angular/fire/auth';
import { Router, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { user } from 'rxfire/auth';
import { firstValueFrom } from 'rxjs';
import { take } from 'rxjs/operators';
import { RouteUtils } from '../route-utils.service';

@Injectable()
export class NotAuthenticatedGuard {
	constructor(private router: Router, private auth: Auth, private routeUtils: RouteUtils) {}

	public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
		const hasAuth = firstValueFrom(user(this.auth).pipe(take(1)));
		return hasAuth.then((auth) => {
			if (auth) {
				this.redirectToDashboardOrAttemptedUrl();
				return false;
			} else {
				return true;
			}
		});
	}

	public redirectToDashboardOrAttemptedUrl() {
		const url = this.routeUtils.userAttemptedUrl;
		this.routeUtils.userAttemptedUrl = null;
		this.router.navigate([url || '/projects']);
	}
}
